import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=3eaeb320&scoped=true"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eaeb320",
  null
  
)

export default component.exports